var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcNewLink16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_new_link_16",
    transform: "translate(-494.25 -348.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_485",
    "data-name": "Rectangle 485",
    width: 16,
    height: 16,
    transform: "translate(494.25 348.25)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4413",
    "data-name": "Path 4413",
    d: "M504.656,361.75h-7.312a2.1,2.1,0,0,1-2.094-2.094v-7.312a2.1,2.1,0,0,1,2.094-2.094H501a.75.75,0,0,1,0,1.5h-3.656a.6.6,0,0,0-.594.594v7.312a.6.6,0,0,0,.594.594h7.312a.6.6,0,0,0,.594-.594V356a.75.75,0,0,1,1.5,0v3.656A2.1,2.1,0,0,1,504.656,361.75Z",
    fill: "#a0a3c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4414",
    "data-name": "Path 4414",
    d: "M508,353.75a.75.75,0,0,1-.75-.75v-3.25H504a.75.75,0,0,1,0-1.5h4a.75.75,0,0,1,.75.75v4A.75.75,0,0,1,508,353.75Z",
    fill: "#a0a3c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4415",
    "data-name": "Path 4415",
    d: "M500,357.75a.75.75,0,0,1-.53-1.28l8-8a.75.75,0,0,1,1.06,1.06l-8,8A.744.744,0,0,1,500,357.75Z",
    fill: "#a0a3c4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNewLink16);
export default __webpack_public_path__ + "static/media/ic_new_link_16.5b7cb7bfecb539e51300a3d5c137251d.svg";
export { ForwardRef as ReactComponent };